import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
//Component
import { BarMenu } from '../common/BarMenu/BarMenu'
import { Header } from '../common/Header/Header'
import Maps from '../../utils/Maps';
//css

import './branch.css'

import ModalLoginUserClient from '../../layouts/Kiosk_ecommers_stant/ModalLoginUserClient';
import ModalDetailUser from '../../layouts/Kiosk_ecommers_stant/ModalDetailuser';
import ErrorAlert from '../Alerts/ErrorAlert';
import ModalWelcomePage from '../../layouts/Kiosk_ecommers_stant/ModalWelcomePage';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { BusinessFetchAPI } from '../../api/Business';
import { AuthFetchAPI } from '../../api/Auth';
import { MachinesFetchAPI } from '../../api/Machines';
import { ClientsFetchAPI } from '../../api/Clients';
import { TablesFetchAPI } from '../../api/Tables';
import { ParthnerFetchAPI } from '../../api/Parthner';
import LoginStand from '../Profile/LoginStand';
//Icons
import { MenuBar } from '../../layouts/Kiosk_ecommers_stant/components/MenuBar/MenuBar';
import HeaderMain from '../Home/Headers/HeaderMain';
import Loader from '../Home/Loader';
import { buildCloudinaryImageUrl } from "../../utils/CloudinaryImageUrl";

function BranchofficeSelect() {
    const { business_code, tableCode, type } = useParams();

    /*const [showModalWelcomePage, setShowModalWelcomePage] = useState(() => {
        if (tableCode != undefined) {
            return true
        } else {
            return false
        }
    });*/
    const [showModalWelcomePage, setShowModalWelcomePage] = useState(false)
    const [modalStand, setModalStand] = useState(false)
    const [branchoffices, setBranchoffices] = useState([])
    const [background, setBackground] = useState('')
    const [businessinfo, setBusinessinfo] = useState({ id: 0 })
    const [showModal, setShowModal] = useState(false);
    const [showModalDetail, setShowModalDetail] = useState(false);
    const [dataClient, setDataClient] = useState({ client_name: 'Soy usuario', client_id: '0', client_ruc: "0000-00", client_ruc: "00" })
    const [dataTable, setDataTable] = useState({ name: 'Soy un stan' })
    const [pageLoader, setPageLoader] = useState(0)
    const [clients, setClients] = useState([])
    //const [tables, setTables] = useState([]);
    const [typeUser, setTypeUser] = useState('')
    const [token, setToken] = useState('')
    const [parthners, setParthners] = useState([])
    const [logo, setLogo] = useState('')
    const [tableNow, setTableNow] = useState({ label: "" })
    const [eventHandler, setEventHandlers] = useState(0)
    // const [step, setStep] = useState(0);
    const navigate = useNavigate();

    let count = 0
    let lengthArrayRestaurant = 0
    let arrayTempBranch1 = []
    let arrayTempBranch2 = []
    const validLengthArrayRestaurant = (data, request) => {

        if (type != "true" && tableCode == undefined) {

            lengthArrayRestaurant = (lengthArrayRestaurant + data.length)
            count = count + 1



            if (request == 1) {
                arrayTempBranch1 = data
            } else {
                arrayTempBranch2 = data
            }

            if (count == 2) {

                if (lengthArrayRestaurant == 1) {

                    handleSave(arrayTempBranch1)
                } else {

                }

                arrayTempBranch1 = []
                arrayTempBranch2 = []
                count = 0
                lengthArrayRestaurant = 0
            }
        }
    }



    const branchByBusines = async (business) => {

        try {
            const response = await BranchOfficeFetchAPI.getBranchOfficesByBusiness(business.id)
            const branchResult = response.data.data.filter(({ state }) => state === 1);
            setBranchoffices(branchResult)
            validLengthArrayRestaurant(branchResult, 1)
            setEventHandlers(1)

            if (branchResult.length == 1) {
                handleSaveBranchoffice(branchResult[0])
            }
        } catch (err) {
            validLengthArrayRestaurant([], 1)

        }
    }

    //get parthners of the business
    const getParthners = async (token) => {

        let data = businessinfo
        try {
            const response = await ParthnerFetchAPI.getBusinessParthners(token);
            //setParthners(response.data.parthners);



            setParthners(response.data.parthners)
            validLengthArrayRestaurant(response.data.parthners, 2)



        } catch (err) {
            validLengthArrayRestaurant([], 2)

        }
    }

    //save and select parthner
    const selectRestaurant = (data) => {
        validToken(0, false, businessinfo);

        let jsonNewParthner = { id: data.parthner_branchoffice_id, name: data.parthner_name, code: data.code, branchoffice_open: null, branchoffice_printer: null, branchoffice_support_phone: data.phone }
        localStorage.setItem('branchoffice', JSON.stringify(jsonNewParthner))

        if (data.parthner_branch_machine_id !== null) {
            getInfoMachine(data.parthner_branch_machine_id, data)
        }

        localStorage.setItem('logo', data.logo)
    }

    //function get machine info
    const getInfoMachine = async (machine_id, dataBranchoffice) => {
        try {
            const response = await MachinesFetchAPI.getmachineByid(machine_id, token)
            let infoMachineJson = response.data.data


            let jsonNewMachine = {
                id: infoMachineJson.machine_per_branch_id,
                code: infoMachineJson.code,
                is_logged: 0,
                name_type_machine: infoMachineJson.name_type_machine,
                machine_type_id: infoMachineJson.machine_type_id,
                printers: infoMachineJson.printers,
                machine_config: infoMachineJson.machine_config
            }

            localStorage.setItem('machine', JSON.stringify(jsonNewMachine));
            localStorage.setItem('parthner_order', true);
            // navigate(`/kiosk/ecommers/stant/${business_code}/${dataBranchoffice.code}/${jsonNewMachine.code}`)

            //navigate(`/home/${business_code}/${dataBranchoffice.code}/${jsonNewMachine.code}`)
            navigate(`/home`)
        } catch (err) {

        }
    }



    const getBusinessByCode = async () => {
        try {
            const response = await BusinessFetchAPI.getBusinessByCode(business_code)

            localStorage.setItem('logo', response.data.businessConfig.logo);
            setLogo(response.data.businessConfig.logo)
            setBackground(response.data.businessConfig.background)
            branchByBusines(response.data.business);

            let dataBusiness = {
                "id": response.data.business.id,
                "name": response.data.business.name,
                "description": response.data.business.description,
                "code": response.data.business.code,
                "config": null
            }

            if (localStorage.getItem('client') !== '' && localStorage.getItem('client') !== undefined && localStorage.getItem('client') !== null) {
                setDataClient(JSON.parse(localStorage.getItem('client')))
            }

            /*if (localStorage.getItem('table') !== '' && localStorage.getItem('table') !== undefined && localStorage.getItem('table') !== null) {
                setDataTable(JSON.parse(localStorage.getItem('table')))
            }*/


            setBusinessinfo(dataBusiness)
            localStorage.setItem('businessConfig', JSON.stringify(response.data.businessConfig))
            localStorage.setItem("frecuentShopperConfig", response.data.frecuentShopperConfig !== null ? JSON.stringify(response.data.frecuentShopperConfig) : null);
            localStorage.setItem('business', JSON.stringify(dataBusiness))
            validToken(0, true, dataBusiness);


        } catch (err) {

        }
    }

    const getBranchOfficeByCode = async (branchoffice_code, token) => {
        try {
            const response = await BranchOfficeFetchAPI.getBranchOfficeByCode(business_code, branchoffice_code, token)

            let branchoffice_info = response.data.branchoffice
            let machine_ecommerce = response.data.branchoffice.machine_ecommerce
            let machine_table = response.data.branchoffice.machine_table
            let data_branchoffice = {
                "id": branchoffice_info.id,
                "name": branchoffice_info.name,
                "code": branchoffice_info.code,
                "order_printed": branchoffice_info.printed_order,
                "branchoffice_printer": branchoffice_info.printer_name,
                "branchoffice_support_phone": branchoffice_info.supportPhone,
                "branchoffice_open": branchoffice_info.branchoffice_open,
                'machine_ecommerce': machine_ecommerce,
                'machine_table': machine_table
            }


            if (machine_ecommerce !== null) {
                if (machine_ecommerce.length > 0) {
                    getMachineByCode(branchoffice_code, token, machine_ecommerce[0].code)
                } else {
                    ErrorAlert('', 'Esta sucursal no tiene eccomerce', 'warning')
                }
            } else {
                ErrorAlert('', 'Esta sucursal no tiene eccomerce', 'warning')
            }


            localStorage.setItem('branchoffice', JSON.stringify(data_branchoffice));
            localStorage.setItem('branchoffice_original', JSON.stringify(data_branchoffice));


        } catch (err) {

        }


    }


    const generateToken = async (branchoffice_code, stateModalLog, dataBusiness) => {


        let business_id = 0
        if (dataBusiness === undefined) {
            business_id = businessinfo.id;
        } else {
            business_id = dataBusiness.id
        }

        try {
            const response = await AuthFetchAPI.generatePublicToken(business_id);
            if (response?.data?.success === false) return;


            setToken('')
            //getParthners()
            getTablesByBusiness(business_id)
            if (stateModalLog !== true) {
                getBranchOfficeByCode(branchoffice_code)
            }

            //authMachine(branchoffice_code)
        } catch (err) {

        }
    }

    const validToken = async (branchoffice_code, stateModalLog, dataBusiness) => {


        try {
            const response = await AuthFetchAPI.validToken();
            if (response.data === true) {

                setToken('');
                //getParthners()
                getTablesByBusiness(dataBusiness.id)
                if (stateModalLog !== true) {
                    getBranchOfficeByCode(branchoffice_code)
                }
            } else {
                generateToken(branchoffice_code, stateModalLog, dataBusiness)
            }
        } catch (err) {

            generateToken(branchoffice_code, stateModalLog, dataBusiness)
        }
    }



    const getMachineByCode = async (branchoffice_code, token, machine_code) => {
        try {
            const response = await MachinesFetchAPI.getMachineByCode(machine_code, branchoffice_code, token);
            let machines_info = response.data.machine

            let data = {
                "id": machines_info.id,
                "code": machines_info.code,
                "is_logged": machines_info.is_logged,
                "name_type_machine": machines_info.name_type_machine,
                "machine_type_id": machines_info.machine_type_id,
                "printers": [],
                "machine_config": {
                    "mainContainer": true,
                    "deliveryGroup": {
                        "actvPlus": true
                    },
                    "buttons": {
                        "groupPlus": true,
                        "groupLite": false,
                        "menu": {
                            "groupPlus": true,
                            "topNav": false,
                            "actvLite": false
                        },
                        "discounts": {
                            "actvPlus": true,
                            "actvLite": false
                        },
                        "coupons": {
                            "actvPlus": true,
                            "actvLite": false
                        },
                        "pendingOrders": {
                            "actvPlus": true,
                            "actvLite": false
                        },
                        "return": {
                            "actvPlus": true,
                            "actvLite": false
                        }
                    }
                },
                "machine_open": machines_info.machine_open
            }

            localStorage.setItem('machine', JSON.stringify(data));
            localStorage.setItem('parthner_order', false);
            navigate(`/home`)
            //navigate(`/home/${business_code}/${branchoffice_code}/${machine_code}`)
            // navigate(`/kiosk/ecommers/stant/${business_code}/${branchoffice_code}/${machine_code}`)
        } catch (err) {

        }
    }



    const getTablesByBusiness = async (businessinfo_id, token) => {

        if (tableCode != undefined) {
            try {
                const response = await TablesFetchAPI.getBusinessTables(businessinfo_id, token);

                let tablesInfo = []
                response.data.tables.forEach(table => {
                    if (table.status === 1) { tablesInfo.push({ value: table, label: table.name }) }
                });



                //ROOOM SERVICE
                let filterTable = tablesInfo.find((table) => table.value.table_code === tableCode)
                let codeRoom = localStorage.getItem('codeRoom')


                if (filterTable != undefined) {
                    setTableNow(filterTable)
                    if (filterTable.value.open_order == 1) {

                        setShowModalWelcomePage(false)
                        localStorage.setItem('table', JSON.stringify(filterTable.value))
                        localStorage.setItem('codeRoom', filterTable.value.password)

                    } else {
                        if (codeRoom != undefined || codeRoom != '' || codeRoom != null) {
                            if (codeRoom == filterTable.value.password) {
                                setShowModalWelcomePage(true)
                                localStorage.setItem('table', JSON.stringify(filterTable.value))
                            } else {
                                setShowModalWelcomePage(false)
                                setModalStand(true)
                            }
                        } else {
                            setShowModalWelcomePage(false)
                            setModalStand(true)
                        }
                    }

                }
                //----------------------------------------------
                //setTables(tablesInfo);
            } catch (err) {
            }
        } else {
        }
    }


    const getClientsByBusiness = async () => {

        try {

            const response = await ClientsFetchAPI.getClientsByBusiness(businessinfo.id, token)
            setClients(response.data.data)
        } catch (err) {
        }
    }


    const handleModalSesionValid = (typeUser) => {

        if (typeUser === 'stan') {
            if (dataTable.name === 'Soy un stan') {
                setShowModal(true)

                setTypeUser(typeUser)
                getTablesByBusiness()
            } else {
                setShowModalDetail(true)
            }
        } else if (typeUser === 'client') {
            if (dataClient.client_name === 'Soy usuario') {
                setShowModal(true)

                setTypeUser(typeUser)
                getClientsByBusiness()
            } else {
                setShowModalDetail(true)
            }
        }

    }


    const handleSaveBranchoffice = (branchoffice) => {
        let data = {
            "id": branchoffice.branchofficeId,
            "name": branchoffice.branchofficeName,
            "code": branchoffice.branchoffice_code,
            "order_printed": 0,
            "branchoffice_printer": null,
            "branchoffice_support_phone": "",
            "branchoffice_open": 1
        };



        localStorage.setItem('branchoffice', JSON.stringify(data));
        validToken(branchoffice.branchoffice_code, false, businessinfo);
    }

    const clearParamslocal = () => {
        localStorage.removeItem('x-access-machine-token')
        localStorage.setItem('branchoffice', '')
        localStorage.setItem('machine', '')
        localStorage.setItem('business', '')
        localStorage.setItem('logo', '')
        localStorage.setItem('parthner_order', '')
        localStorage.setItem('selectedCategorie', '')
        localStorage.setItem('shoppingCart', '')
    }

    const handleSave = (data) => {
        let branchofficeArray = []
        if (data !== undefined) {
            branchofficeArray = data
        } else {
            branchofficeArray = branchoffices
        }
        if (branchofficeArray.length > 0) {
            handleSaveBranchoffice(branchofficeArray[0])
        }
        else {
            setShowModalWelcomePage(false)
        }
    }


    useEffect(() => {
        clearParamslocal()
        getBusinessByCode();
        setPageLoader(0)
    }, [pageLoader])
    const [loading, setLoading] = useState(true);
    return (
        <>
            {loading && <Loader onFinish={() => setLoading(false)} />}
            {!loading &&
                (<>

                    <div className="hero-wrapper ">
                        <HeaderMain />
                        <main>
                            <div className=' product-ecommerce-container'>
                                <div className='container d-flex justify-content-between align-items-center '>
                                    <div>
                                        <h4 className="py-lg-2 py-1 m-0">Restaurantes</h4>

                                    </div>
                                </div>
                            </div>




                            <main className=''>


                                <div className='container'>
                                    <div className='row px-3'>


                                        {/* <------  ----->  */}
                                        {parthners.length > 0 ? <>
                                            {parthners.map((parthner) => (
                                                <>
                                                    <div className='col-6 bg-white p-2' onClick={() => selectRestaurant(parthner)}>
                                                        {/* Card */}
                                                        <label className="card-restaurant">
                                                            <span class="badge badge-success rounded-2  position-absolute badge-position">Abierto</span>
                                                            <input name="plan" className="radio" type="radio" />
                                                            <span className="plan-details">
                                                                <div className="d-flex justify-content-start">

                                                                    {/* <img src={parthner.logo}
                                                                        alt="Restaurant" className="rounded-2  border img-restaurant " /> */}

                                                                    <img src={buildCloudinaryImageUrl({ url: parthner.logo, width: 300, quality: "auto", type: "image" })}
                                                                        alt="Restaurant" className="rounded-2  border img-restaurant "

                                                                        onError={e => e.target.style.opacity = 0} />

                                                                </div>
                                                                <span className="plan-type" translate='no'>{parthner.branchoffice_name} </span>
                                                                <p className="plan-description" translate='no'>{parthner.parthner_name}</p>
                                                                <div className="d-flex gap-2">
                                                                    <span class="badge  text-secondary">Restaurant </span>
                                                                </div>
                                                            </span>
                                                        </label>

                                                    </div>
                                                </>
                                            ))}</> : <></>}
                                        {
                                            !branchoffices.length
                                                ? <>
                                                    <div className='col-12 d-flex justify-content-center align-items-center border
                                             p-4 mt-5 bg-blur-sp-2 rounded-4'>
                                                        <h6 className='fw-bold text-dark text-center p-4'>
                                                            No hay Tiendas disponibles
                                                        </h6>
                                                    </div>
                                                </>
                                                : <>
                                                    {branchoffices.map((branchoffice) => (
                                                        <>
                                                            <div className='col-6 col-md-4 bg-white p-2' onClick={() => handleSaveBranchoffice(branchoffice)}>
                                                                <label className="card-restaurant">
                                                                    <span class="badge badge-success rounded-2  position-absolute badge-position">Abierto</span>
                                                                    <input name="plan" className="radio" type="radio" />
                                                                    <span className="plan-details">
                                                                        <div className="d-flex justify-content-start">
                                                                            {/* <img src={logo}
                                                                                alt="Restaurant" className="rounded-2  border img-restaurant " /> */}


                                                                            <img src={buildCloudinaryImageUrl({ url: logo, width: 300, quality: "auto", type: "image" })}
                                                                                alt="Restaurant" className="rounded-2  border img-restaurant "

                                                                                onError={e => e.target.style.opacity = 0} />
                                                                        </div>
                                                                        <span className="plan-type" translate='no'>{branchoffice.branchofficeName}</span>
                                                                        <p className="plan-description" translate='no'>{branchoffice.businessName}</p>

                                                                        <div className="d-flex gap-2">
                                                                            <span class="badge  text-secondary">Restaurante </span>

                                                                        </div>
                                                                    </span>
                                                                </label>

                                                            </div>
                                                        </>
                                                    ))}
                                                </>
                                        }

                                    </div>

                                </div>

                            </main>
                        </main>
                    </div>
                </>)
            }








            {type == "true" ? <></> : <>
                <ModalWelcomePage showModalWelcomePage={showModalWelcomePage} setShowModalWelcomePage={setShowModalWelcomePage} background={background} tableNow={tableNow} handleSaveBranchoffice={handleSaveBranchoffice} branchoffices={branchoffices} handleSave={handleSave}></ModalWelcomePage></>}
            <LoginStand modalStand={modalStand} setModalStand={setModalStand} tableNow={tableNow} background={background} handleSaveBranchoffice={handleSaveBranchoffice} branchoffices={branchoffices} />
        </>
    )
}

export default BranchofficeSelect
